import { combineReducers } from "redux";

import * as runtimeActions from "./runtime/actions";
import * as signActions from "./sign/actions";
import * as userActions from "./UserService/actions";
import runtimeReducer from "./runtime/reducer";
import signReducer from "./sign/reducer";
import userReducer from "./UserService/reducers";

const actions = {
  runtime: runtimeActions,
  sign: signActions,
  userService: userActions,
};
const reducer = combineReducers({
  runtime: runtimeReducer,
  sign: signReducer,
  userService: userReducer,
});

export { actions, reducer };
